"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _LanguageSwitcherPopup = _interopRequireDefault(require("./LanguageSwitcherPopup"));

var _LanguageUtil = _interopRequireDefault(require("../util/LanguageUtil"));

var _default = function _default() {
  var userLanguage = _LanguageUtil.default.getPrintUserLanguage();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      popupOpen = _useState2[0],
      setPopupOpen = _useState2[1];

  var popup = (0, _react.useRef)(null);

  var onClick = function onClick() {
    setPopupOpen(true);
  };

  var onClickedOutside = function onClickedOutside() {
    setPopupOpen(false);
  }; // handles onBlur properly so we don't intercept the anchor tag clicks


  (0, _react.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (popup.current && !popup.current.contains(event.target)) {
        onClickedOutside();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popup]);
  return _react.default.createElement("div", {
    className: "language-switcher-container"
  }, _react.default.createElement("div", {
    ref: popup,
    className: "language-switcher",
    tabIndex: "0",
    onClick: onClick
  }, userLanguage, _react.default.createElement("span", {
    className: "icon icon-angle-down"
  }), _react.default.createElement(_LanguageSwitcherPopup.default, {
    isOpen: popupOpen
  })));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/LanguageSwitcher.js
// module id = 142
// module chunks = 0